export const CHART_COLORS = [
  '#2563eb',
  '#1db954',
  '#e91e63',
  '#f59e0b',
  '#8b5cf6',
  '#06b6d4',
  '#ec4899',
  '#84cc16',
  '#f97316',
  '#14b8a6',
];

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const formatMonthLabel = (yyyyMm) => {
  const [year, month] = yyyyMm.split('-');
  const idx = Number(month) - 1;
  if (!year || idx < 0 || idx > 11) return yyyyMm;
  return `${MONTH_NAMES[idx]} ${year}`;
};

export const buildPieSlices = (items, maxSlices = 6) => {
  const total = items.reduce((sum, item) => sum + item.count, 0);
  if (!total) return { slices: [], total: 0 };

  const top = items.slice(0, maxSlices);
  const otherCount = items
    .slice(maxSlices)
    .reduce((sum, item) => sum + item.count, 0);

  const raw = [...top];
  if (otherCount > 0) {
    raw.push({ label: 'Other', count: otherCount });
  }

  let cumulative = 0;
  const slices = raw.map((item, index) => {
    const percent = (item.count / total) * 100;
    const slice = {
      label: item.label,
      value: item.count,
      percent,
      color: CHART_COLORS[index % CHART_COLORS.length],
      startPercent: cumulative,
      endPercent: cumulative + percent,
    };
    cumulative += percent;
    return slice;
  });

  return { slices, total };
};

export const polarToCartesian = (cx, cy, radius, angleDeg) => {
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  return {
    x: cx + radius * Math.cos(rad),
    y: cy + radius * Math.sin(rad),
  };
};

export const describeDonutSlice = (
  cx,
  cy,
  outerR,
  innerR,
  startAngle,
  endAngle
) => {
  const startOuter = polarToCartesian(cx, cy, outerR, endAngle);
  const endOuter = polarToCartesian(cx, cy, outerR, startAngle);
  const startInner = polarToCartesian(cx, cy, innerR, startAngle);
  const endInner = polarToCartesian(cx, cy, innerR, endAngle);
  const largeArc = endAngle - startAngle > 180 ? 1 : 0;

  return [
    `M ${startOuter.x} ${startOuter.y}`,
    `A ${outerR} ${outerR} 0 ${largeArc} 0 ${endOuter.x} ${endOuter.y}`,
    `L ${startInner.x} ${startInner.y}`,
    `A ${innerR} ${innerR} 0 ${largeArc} 1 ${endInner.x} ${endInner.y}`,
    'Z',
  ].join(' ');
};
